<!-- Hardcoded ids -->

<div class="forgot-password" fxLayout="column" fxLayoutAlign="space-between center" fxFlexFill>
	<div fxFlex fxLayout="row" fxLayoutAlign="center center">
		<mat-card class="padding-25 mat-elevation-z5" fxFlex="370px" fxFlex.lt-sm="90%">
		  <form [formGroup]="forgotPasswordForm" fxLayout="column" (ngSubmit)="forgotPasswordForm.valid && onSubmit(forgotPasswordForm.value)" autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>
	
			<!--Image Logo-->
			<img id="id_forgot_password_img_cfs_logo" class="logo" [src]="imgUrl" alt="E-Science Logo">
	
			<!--Statement Logo-->
			<!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->
	
			<mat-label id="id_forgot_password_lbl_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
			  {{errorMessage}}
			</mat-label>
	
			<mat-form-field>
			  <input id="id_forgot_password_txt_username" matInput [placeholder]="'USERNAME' | translate" formControlName="username" autocomplete="off" required>
			  <mat-error id="id_forgot_password_lbl_username_error_required" *ngIf="forgotPasswordForm.controls['username'].hasError('required')">
				{{ 'MESSAGE_ERROR_USERNAME_REQUIRED' | translate }}
			  </mat-error>
			  <mat-error id="id_forgot_password_lbl_username_error_not_existing" *ngIf="forgotPasswordForm.controls['username'].hasError('notExisting')">
				{{ 'MESSAGE_ERROR_USERNAME_NOT_EXISTING' | translate }}
			  </mat-error>
			  <mat-error id="id_forgot_password_lbl_username_error_invalid" *ngIf="forgotPasswordForm.controls['username'].hasError('whitespace')">
				{{ 'MESSAGE_ERROR_INVALID_USERNAME' | translate }}
			  </mat-error>
			</mat-form-field>
	
			<button id="id_forgot_password_btn_send_verification" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
			  {{ (isSubmitting ? 'SENDING' : 'SEND_VERIFICATION_CODE') | translate }}
			</button>
	
			<div fxLayout="column">
			  <button mat-button 
				id="id_forgot_password_btn_already_have_verification"
				type="button"
				routerLink="../reset-password" 
				[queryParams]="forgotPasswordForm.controls['username'].valid ? { username: forgotPasswordForm.controls['username'].value } : {}"
				color="primary">
				{{ 'ALREADY_HAVE_VERIFICATION_CODE' | translate }}
			  </button>
	  
			  <button mat-button 
				id="id_forgot_password_btn_back"
				type="button"
				routerLink="../login" 
				[queryParams]="forgotPasswordForm.controls['username'].valid ? { username: forgotPasswordForm.controls['username'].value } : {}"
				color="primary">
				{{ 'RETURN_TO_LOGIN' | translate }}
			  </button>
			</div>
	
		  </form>
		</mat-card>
	  </div>
	  <div fxFlexAlign="end">
		<esc-footer></esc-footer>
	  </div>
</div>